/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import RadiationDosimetry from './radiation-dosimetry';
import RadiationDosimetryDetail from './radiation-dosimetry-detail';
import RadiationDosimetryUpdate from './radiation-dosimetry-update';
import RadiationDosimetryDeleteDialog from './radiation-dosimetry-delete-dialog';

const RadiationDosimetryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<RadiationDosimetry />} />
    <Route path="new" element={<RadiationDosimetryUpdate />} />
    <Route path=":id">
      <Route index element={<RadiationDosimetryDetail />} />
      <Route path="edit" element={<RadiationDosimetryUpdate />} />
      <Route path="delete" element={<RadiationDosimetryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RadiationDosimetryRoutes;
